import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-4a94180b"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "no-user-content"
};
const _hoisted_2 = {
  class: "login-content"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "开启智慧教学之旅", -1));

const _hoisted_4 = {
  class: "avatar"
};
const _hoisted_5 = ["src"];

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px"
  }
}, "账号登录", -1));

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-chakanquanbu"
}, null, -1));

const _hoisted_8 = [_hoisted_6, _hoisted_7];
const _hoisted_9 = {
  key: 1,
  style: {
    "position": "relative",
    "height": "100%"
  }
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "toggle-tip"
}, [/*#__PURE__*/_createElementVNode("span", null, "切换用户"), /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-qiehuan"
})], -1));

const _hoisted_11 = {
  key: 1,
  class: "user-content"
};
const _hoisted_12 = {
  class: "top-text"
};
const _hoisted_13 = {
  class: "user-name"
};
const _hoisted_14 = {
  key: 2,
  class: "user-content"
};
const _hoisted_15 = {
  class: "top-text"
};
const _hoisted_16 = {
  class: "user-name"
};
const _hoisted_17 = {
  key: 3,
  class: "user-content"
};
const _hoisted_18 = {
  class: "top-text"
};
const _hoisted_19 = {
  class: "user-name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

  const _component_el_dropdown = _resolveComponent("el-dropdown");

  const _component_RoleCard = _resolveComponent("RoleCard");

  return _openBlock(), _createElementBlock(_Fragment, null, [!$props.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
    src: require('@/assets/images/home/Booklist.png'),
    alt: ""
  }, null, 8, _hoisted_5)]), _createElementVNode("div", {
    class: "login-button",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.zhsLogin && $options.zhsLogin(...args))
  }, _hoisted_8)])])) : _createCommentVNode("", true), $props.userInfo ? (_openBlock(), _createElementBlock("div", _hoisted_9, [$props.zhsRole == 1 || $props.zhsRole == 2 ? (_openBlock(), _createBlock(_component_el_dropdown, {
    key: 0,
    trigger: "hover",
    "append-to-body": false,
    "show-arrow": false
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
      class: "role-dropdown"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.roleList, (item, index) => {
        return _openBlock(), _createBlock(_component_el_dropdown_item, {
          key: item.name,
          onClick: $event => $options.toggleZhsRole(item, index)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
          _: 2
        }, 1032, ["onClick"]);
      }), 128))]),
      _: 1
    })]),
    default: _withCtx(() => [_hoisted_10]),
    _: 1
  })) : _createCommentVNode("", true), $data.currentRole == 3 || $data.currentRole == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("span", _hoisted_13, _toDisplayString($props.userInfo.realname), 1)]), _createVNode(_component_RoleCard, {
    menuList: $data.appList,
    zhsRole: $data.currentRole,
    onlineLink: $data.onlineLink.student
  }, null, 8, ["menuList", "zhsRole", "onlineLink"])])) : _createCommentVNode("", true), $data.currentRole == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("span", _hoisted_16, _toDisplayString($props.userInfo.realname) + "老师", 1)]), _createVNode(_component_RoleCard, {
    menuList: $data.appList,
    zhsRole: $data.currentRole,
    onlineLink: $data.onlineLink.teacher
  }, null, 8, ["menuList", "zhsRole", "onlineLink"])])) : _createCommentVNode("", true), $data.currentRole == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("span", _hoisted_19, _toDisplayString($props.userInfo.realname) + "管理员", 1)]), _createVNode(_component_RoleCard, {
    menuList: $data.appList,
    zhsRole: $data.currentRole,
    onlineLink: $data.onlineLink.manage
  }, null, 8, ["menuList", "zhsRole", "onlineLink"])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 64);
}